import { render } from "./CommunitiesnIndigenous.vue?vue&type=template&id=b0056f00&scoped=true"
import script from "./CommunitiesnIndigenous.vue?vue&type=script&lang=js"
export * from "./CommunitiesnIndigenous.vue?vue&type=script&lang=js"

import "./CommunitiesnIndigenous.vue?vue&type=style&index=0&id=b0056f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0056f00"]])

export default __exports__